export default __webpack_public_path__ + "static/media/EUROPE.1b00c5a9.svg";